
import { Component, Vue } from 'vue-property-decorator';
import { iColumnTabel } from '@/interface/column';
import { getChargeConsume, getTotalChargeConsume } from '@/api/statistics';
import { iSelectOptionsList } from '@/interface/cancel-detail';
import ShortcutDate from '@/components/shortcutdate/shortcutdate.vue';
import moment from 'moment';
import { log } from 'util';
@Component({
  components: { ShortcutDate },
})
export default class extends Vue {
  public dates: (string | Date)[] = [];
  private pickerBeginDateBefore: { disabledDate: Function } = {
    disabledDate(time: any) {
      return time.getTime() > Date.now() - 3600 * 1000 * 24;
    },
  };
  private initDay: number | string = 1;
  private total = 0;
  loading: boolean = false;
  rechargeTable: any[] = [];
  consumTable: any[] = [];
  totalNumInfo = {};
  params: { page_size: number; page: number; end: number; start: number } = {
    page_size: 10,
    page: 1,
    start: 0,
    end: 0,
  };
  //快捷日期:
  private shortcutDays: iSelectOptionsList[] = [
    { label: '昨日', value: 1 },
    { label: '近7天', value: 7 },
    { label: '近15天', value: 15 },
    { label: '近30天', value: 30 },
    { label: '统计数据不包含当天', value: 0 },
  ];
  defaultDays: { day: number; initDay: number } = { day: 7, initDay: 1 }; // 默认近7天
  getShortcutTimeFn(dates: (string | Date)[], params: { start: number; end: number }, activeIndex: number) {
    this.initDay = activeIndex;
    this.dates = dates;
    this.params.start = params.start;
    this.params.end = params.end;
    this.params.page = 1;
    this.getListData();
    this.getTotalNum();
  }
  dateHandler(datavalue: Date[]) {
    this.initDay = '';
    this.params.start = Math.floor(datavalue[0].getTime() / 1000);
    this.params.end = Math.floor(datavalue[1].getTime() / 1000) + 3600 * 24 - 1;
    this.params.page = 1;
    this.getListData();
    this.getTotalNum();
  }
  handleSizeChange(page_size: number) {
    this.params.page = 1;
    this.params.page_size = page_size;
    this.getListData();
  }
  handleCurrentChange(page: number) {
    this.params.page = page;
    this.getListData();
  }
  async getListData() {
    this.loading = true;
    const res = await getChargeConsume(this.params);
    if (res && res.code == 0) {
      this.total = res.data.total;
      this.rechargeTable = res.data.charge_list;
      this.consumTable = res.data.consume_list;
    }
    this.loading = false;
  }
  async getTotalNum() {
    const res = await getTotalChargeConsume({ start: this.params.start, end: this.params.end });
    if (res && res.code == 0) {
      this.totalNumInfo = res.data;
    }
  }
}
